import React from 'react';
import PropTypes from 'prop-types';

import Header from '../../blocks/Header';
import PanelBanner from '../../blocks/PanelBanner';
import SplitImages from '../../blocks/SplitImages';
import SplitBackground from '../../blocks/SplitBackground';
import Usps from '../../blocks/Usps';
import ProductsPresentation from '../../blocks/ProductsPresentation';
import Footer from '../../blocks/Footer';
import scrollToTopOrHash from '../../utils/helpers/scrollToTopOrHash';
import { sendPageView } from '../../utils/helpers/ga';

import coffeeCodeImage from './assets/coffee-code.jpg';
import webImage from './assets/web.jpg';
import networkImage from './assets/network.jpg';
import techImage from './assets/tech.jpg';
import hostingSvg from '../../common/assets/icons/hosting.svg';
import websiteSvg from '../../common/assets/icons/website.svg';

class Home extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      scrollToTopOrHash();
      window.document.title = 'ScandGate AB - IT-leverantören 2018';
      sendPageView(this.props.location.pathname);
    }
  }

  render() {
    return (
      <div>
        <Header currentLocation={this.props.location.pathname} />

        <PanelBanner
          leftHeadline="ScandGate - den digitala porten i norr "
          leftText="Det självklara valet för växande företag"
          rightHeadline="IT-partnern du kan lita på"
          background={coffeeCodeImage}
        />

        <SplitImages
          leftImage={networkImage}
          leftText="Helpdesk"
          leftLink="/helpdesk/"
          rightImage={webImage}
          rightText="Kontakt"
          rightLink="/kontakta-oss/"
        />

        <Usps
          headline="Varför ScandGate?"
          usps={[
            'Vi tillhandahåller ert företag en integrerad supportavdelning',
            'Ni får ett eget dedikerat 010-nummer i vår telefonväxel',
            'Felanmälningsformulär på er webbplats kopplas till vår Helpdesk',
          ]}
        />

        <SplitBackground image={techImage}>
          <h1>Teknisk kundtjänst hos oss?</h1>
          <p>
             <i>
              Vår ambition är vi på mest optimala sätt kan assistera era kunder utan att kunderna upplever en
              “extern” Helpdesk som något mindre än en kompetent intern supportavdelning.</i>
          </p>
          <p>
              ScandGate kan avlasta eller ersätta er interna supportverksamhet samtidigt som en kostnadseffektivisering
              sker. Vi är placerade i Gävle men arbetar på nationell basis. Vi kan teknisk support.
              Vår ambition är att växa i takt med våra samarbetspartners för att på sikt komma närmare ett än mer
              djupgående samarbete.
          </p>
          <p>
              Vi ser fram emot att få samarbeta med er.
          </p>
        </SplitBackground>

        <ProductsPresentation
          headline="Våra tjänster"
          leftHeadline="1:st Line Support"
          leftUsps={[
            'Kompetent supportpersonal',
            'Integrerat ticketsystem',
            'Eget dedikerat 010-nummer',
              ]}
          leftIcon={hostingSvg}
          leftLink="/helpdesk/"
          rightHeadline="2:nd Line Support"
          rightUsps={[
            'Varierande programspråkskompetens',
            'Rapportering & uppföljning via Jira',
            'Kan samarbeta med er 3:rd Line Support',
          ]}
          rightIcon={websiteSvg}
          rightLink="/helpdesk#secondline"
        />

        <Footer />
      </div>
    );
  }
}

Home.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Home;



// WEBPACK FOOTER //
// ./pages/Home/index.js